// extracted by mini-css-extract-plugin
export default {"root":"section_root__XF-IY","header":"section_header__+5vSs","title":"section_title__lkpnz","extra":"section_extra__H+jjh","back":"section_back__N9t1s"};